<!--  -->
<template>
<div class=''></div>
</template>

<script>

export default {
components: {},
data() {
return {

};
},
computed: {},
watch: {},
methods: {

},
created() {

},
mounted() {
    window.location.replace(`${window.location.origin}/ark/pullnew/helper/${window.location.search}`)
},
}
</script>